import React from 'react';
import Banner from '../Banner/Banner';
import Feature from '../Feature/Feature';

const Home = () => {
    return (
        <div>
            <Banner></Banner>
            <Feature></Feature>
        </div>
    );
};

export default Home;